import { render, staticRenderFns } from "./CodeEditor.vue?vue&type=template&id=263a5b36&"
import script from "./CodeEditor.vue?vue&type=script&lang=js&"
export * from "./CodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./CodeEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CodeEditor.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/CodeEditor.vue
// module id = 318
// module chunks = 1